const INITIAL_STATE = {
  auth_ongoing: false,
  isAuthenticated: false,
  auth_error: null,
  user_id: null,
  username: "Anonymous",
  loggingOut: false,
  pipeline: null,
  sfa_capabilities: null,
  app_type: "",
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case "AUTH_ONGOING":
      return {
        ...state,
        auth_ongoing: true,
        auth_error: null,
      };

    case "AUTHENTICATION_SUCCESS":
      return {
        ...state,
        auth_ongoing: false,
        isAuthenticated: true,
        auth_error: null,
        api_token: payload.api_token,
      };

    case "AUTHENTICATION_FAILED":
      return {
        ...state,
        auth_ongoing: false,
        auth_error: payload,
      };

    case "SET_USER_DATA":
      let { username, user_id, pc_name, sfa_capabilities, app_type } = payload;
      return {
        ...state,
        username,
        user_id,
        pc_name,
        sfa_capabilities,
        app_type: app_type || "",
      };

    case "LOGGING_OUT":
      return {
        ...state,
        loggingOut: true,
      };

    case "LOGOUT":
      return {
        ...INITIAL_STATE,
      };

    default:
      return {
        ...state,
      };
  }
};
